// Skills.js
import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Skills = () => {
  const skillsRef = useRef(null);

  useEffect(() => {
    const cards = skillsRef.current.querySelectorAll(".skill-card");
    const pasek = skillsRef.current.querySelectorAll(".bgpasek");
    // Ustaw początkowy stan kart
    gsap.set(cards, { opacity: 0, y: 50 });

    gsap.to(cards, {
      opacity: 1,
      y: 0,
      duration: 0.3,
      ease: "power2.out",
      stagger: 0.3, // karty animują się po kolei
      scrollTrigger: {
        trigger: skillsRef.current,
        start: "top top",
        toggleActions: "play none none reverse", // animacja odtwarzana tylko raz
      },
    });

    gsap.to(pasek, {
      x: 300, // ile px przesunie się w prawo
      ease: "none",
      scrollTrigger: {
        trigger: skillsRef.current,
        start: "top top",
        end: "bottom -50%", // kiedy animacja się zacznie
        scrub: true, // synchronizacja animacji z scrollowaniem
      },
    });
  }, []);

  return (
    <div className="skills" ref={skillsRef}>
      <div className="bgpasek"></div>

      <h2>Skills</h2>
      <div className="skill-cards-wrapper">
        <div className="skill-card">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 10.11c1.03 0 1.87.84 1.87 1.89c0 1-.84 1.85-1.87 1.85S10.13 13 10.13 12c0-1.05.84-1.89 1.87-1.89M7.37 20c.63.38 2.01-.2 3.6-1.7c-.52-.59-1.03-1.23-1.51-1.9a23 23 0 0 1-2.4-.36c-.51 2.14-.32 3.61.31 3.96m.71-5.74l-.29-.51c-.11.29-.22.58-.29.86c.27.06.57.11.88.16zm6.54-.76l.81-1.5l-.81-1.5c-.3-.53-.62-1-.91-1.47C13.17 9 12.6 9 12 9s-1.17 0-1.71.03c-.29.47-.61.94-.91 1.47L8.57 12l.81 1.5c.3.53.62 1 .91 1.47c.54.03 1.11.03 1.71.03s1.17 0 1.71-.03c.29-.47.61-.94.91-1.47M12 6.78c-.19.22-.39.45-.59.72h1.18c-.2-.27-.4-.5-.59-.72m0 10.44c.19-.22.39-.45.59-.72h-1.18c.2.27.4.5.59.72M16.62 4c-.62-.38-2 .2-3.59 1.7c.52.59 1.03 1.23 1.51 1.9c.82.08 1.63.2 2.4.36c.51-2.14.32-3.61-.32-3.96m-.7 5.74l.29.51c.11-.29.22-.58.29-.86c-.27-.06-.57-.11-.88-.16zm1.45-7.05c1.47.84 1.63 3.05 1.01 5.63c2.54.75 4.37 1.99 4.37 3.68s-1.83 2.93-4.37 3.68c.62 2.58.46 4.79-1.01 5.63c-1.46.84-3.45-.12-5.37-1.95c-1.92 1.83-3.91 2.79-5.38 1.95c-1.46-.84-1.62-3.05-1-5.63c-2.54-.75-4.37-1.99-4.37-3.68s1.83-2.93 4.37-3.68c-.62-2.58-.46-4.79 1-5.63c1.47-.84 3.46.12 5.38 1.95c1.92-1.83 3.91-2.79 5.37-1.95M17.08 12c.34.75.64 1.5.89 2.26c2.1-.63 3.28-1.53 3.28-2.26s-1.18-1.63-3.28-2.26c-.25.76-.55 1.51-.89 2.26M6.92 12c-.34-.75-.64-1.5-.89-2.26c-2.1.63-3.28 1.53-3.28 2.26s1.18 1.63 3.28 2.26c.25-.76.55-1.51.89-2.26m9 2.26l-.3.51c.31-.05.61-.1.88-.16c-.07-.28-.18-.57-.29-.86zm-2.89 4.04c1.59 1.5 2.97 2.08 3.59 1.7c.64-.35.83-1.82.32-3.96c-.77.16-1.58.28-2.4.36c-.48.67-.99 1.31-1.51 1.9M8.08 9.74l.3-.51c-.31.05-.61.1-.88.16c.07.28.18.57.29.86zm2.89-4.04C9.38 4.2 8 3.62 7.37 4c-.63.35-.82 1.82-.31 3.96a23 23 0 0 1 2.4-.36c.48-.67.99-1.31 1.51-1.9"
            />
          </svg>
          <p>React</p>
        </div>

        <div className="skill-card">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <g fill="none">
              <g clip-path="url(#akarIconsJavascriptFill0)">
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M0 0h24v24H0zm18.347 20.12c-1.113 0-1.742-.58-2.225-1.37l-1.833 1.065c.662 1.308 2.015 2.306 4.11 2.306c2.142 0 3.737-1.112 3.737-3.143c0-1.883-1.082-2.72-2.998-3.543l-.564-.241c-.968-.42-1.387-.693-1.387-1.37c0-.547.42-.966 1.08-.966c.647 0 1.064.273 1.451.966l1.756-1.127c-.743-1.307-1.773-1.806-3.207-1.806c-2.014 0-3.303 1.288-3.303 2.98c0 1.835 1.08 2.704 2.708 3.397l.564.242c1.029.45 1.642.724 1.642 1.497c0 .646-.597 1.113-1.531 1.113m-8.74-.015c-.775 0-1.098-.53-1.452-1.16l-1.836 1.112c.532 1.126 1.578 2.06 3.383 2.06c1.999 0 3.368-1.063 3.368-3.398v-7.7h-2.255v7.67c0 1.127-.468 1.416-1.209 1.416"
                  clip-rule="evenodd"
                />
              </g>
              <defs>
                <clipPath id="akarIconsJavascriptFill0">
                  <path fill="#fff" d="M0 0h24v24H0z" />
                </clipPath>
              </defs>
            </g>
          </svg>
          <p>JavaScript</p>
        </div>

        <div className="skill-card">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="m12 18.178l4.62-1.256l.623-6.778H9.026L8.822 7.89h8.626l.227-2.211H6.325l.636 6.678h7.82l-.261 2.866l-2.52.667l-2.52-.667l-.158-1.844h-2.27l.329 3.544zM3 2h18l-1.623 18L12 22l-7.377-2z"
            />
          </svg>
          <p>HTML5 / PHP</p>
        </div>

        <div className="skill-card">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="m22.059 1l-1.098 19.208l-8.96 3.36l-8.962-3.36L1.941 1zM6.267 15.463v.004l.115 1.994L12 19.568l5.618-2.107l.405-7.084h-7.09l7.29-3.49L18.33 5H5.482l.264 2.012L12.001 7h1.353l-7.369 3.528l.106 1.849h9.814l-.21 3.67L12 17.431l-3.696-1.386l-.04-.69l-.061-1.283h-2.01z"
            />
          </svg>
          <p>CSS / SCSS</p>
        </div>

        <div className="skill-card">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              fill-rule="evenodd"
              d="M8.667 9.417a2.583 2.583 0 1 0 0 5.166h2.583V9.417zm2.583-1.5H8.667a2.583 2.583 0 0 1 0-5.167h2.583zm1.5-5.167v5.167h2.583a2.584 2.584 0 0 0 0-5.167zm2.583 6.666a2.583 2.583 0 0 0-2.583 2.542v.083a2.583 2.583 0 1 0 2.583-2.625m-6.666 6.667a2.584 2.584 0 1 0 2.583 2.584v-2.584z"
              clip-rule="evenodd"
            />
          </svg>
          <p>FIGMA</p>
        </div>

        <div className="skill-card">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10s10-4.49 10-10S17.51 2 12 2M3.01 12c0-1.3.28-2.54.78-3.66l4.29 11.75c-3-1.46-5.07-4.53-5.07-8.09M12 20.99c-.88 0-1.73-.13-2.54-.37l2.7-7.84l2.76 7.57c.02.04.04.09.06.12c-.93.34-1.93.52-2.98.52m1.24-13.21c.54-.03 1.03-.09 1.03-.09c.48-.06.43-.77-.06-.74c0 0-1.46.11-2.4.11c-.88 0-2.37-.11-2.37-.11c-.48-.02-.54.72-.05.75c0 0 .46.06.94.09l1.4 3.84l-1.97 5.9l-3.27-9.75c.54-.02 1.03-.08 1.03-.08c.48-.06.43-.77-.06-.74c0 0-1.46.11-2.4.11c-.17 0-.37 0-.58-.01C6.1 4.62 8.86 3.01 12 3.01c2.34 0 4.47.89 6.07 2.36c-.04 0-.08-.01-.12-.01c-.88 0-1.51.77-1.51 1.6c0 .74.43 1.37.88 2.11c.34.6.74 1.37.74 2.48c0 .77-.3 1.66-.68 2.91l-.9 3zm6.65-.09a8.99 8.99 0 0 1-3.37 12.08l2.75-7.94c.51-1.28.68-2.31.68-3.22c0-.33-.02-.64-.06-.92"
            />
          </svg>
          <p>WordPress</p>
        </div>

        <div className="skill-card">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12.03 2c-.82 0-1.62.07-2.33.2c-2.07.37-2.45 1.14-2.45 2.56v1.88h4.9v.63H5.41c-1.42 0-2.66.85-3.05 2.47c-.45 1.85-.47 3 0 4.93c.35 1.44 1.18 2.47 2.6 2.47h1.68v-2.23c0-1.61 1.39-3.03 3.05-3.03h4.89c1.36 0 2.45-1.12 2.45-2.5V4.76c0-1.34-1.13-2.35-2.45-2.56c-.83-.14-1.71-.2-2.55-.2m-2.65 1.51c.51 0 .92.42.92.94s-.41.93-.92.93s-.92-.41-.92-.93s.41-.94.92-.94M11.97 22c.82 0 1.62-.07 2.33-.2c2.07-.37 2.45-1.14 2.45-2.56v-1.88h-4.9v-.63h6.74c1.42 0 2.66-.85 3.05-2.47c.45-1.85.47-3 0-4.93c-.35-1.44-1.18-2.47-2.6-2.47h-1.68v2.23c0 1.61-1.39 3.03-3.05 3.03H9.42c-1.36 0-2.45 1.12-2.45 2.5v4.62c0 1.34 1.13 2.35 2.45 2.56c.83.14 1.71.2 2.55.2m2.65-1.51c-.51 0-.92-.42-.92-.94s.41-.93.92-.93s.92.41.92.93s-.41.94-.92.94"
            />
          </svg>
          <p>Python</p>
        </div>
      </div>
    </div>
  );
};

export default Skills;
